// extracted by mini-css-extract-plugin
export default {"root":"VideoPlayer_root__VwXxv"};